import { Routes } from '@angular/router';

export const CART_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/cart-index/cart-index.component').then(
            (x) => x.CartIndexComponent,
          ),
      },
    ],
  },
];
